import { motion } from "framer-motion";
import { X, Check } from "lucide-react";
import { PROBLEMS } from "../data/content";
import { Reveal, SectionHead } from "./Reveal";

const SOLUTIONS = ["Individuelle KI-Inszenierungen", "Emotionen, die verkaufen", "Klare technische Grafiken", "Sofortige Aufmerksamkeit", "Höhere Klick- & Kaufrate"];

export const Problem = () => (
  <section id="problem" className="relative py-28 lg:py-40" data-testid="problem-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-8 items-start">
      <div className="lg:col-span-7">
        <SectionHead
          eyebrow="Ausgangslage"
          lines={["Gute Produkte verkaufen", "sich nicht automatisch."]}
          text="Viele Angebote scheitern an einer unprofessionellen Präsentation. Der erste Eindruck entscheidet häufig darüber, ob Interessenten weiterlesen oder weiterscrollen."
        />
        <div className="grid sm:grid-cols-2 gap-x-10 gap-y-3 max-w-2xl">
          <div>
            <p className="eyebrow mb-5 !text-[var(--muted-2)]">Typische Probleme</p>
            <ul className="space-y-3">
              {PROBLEMS.map((p, i) => (
                <Reveal key={p} delay={i * 0.06} y={12}>
                  <li className="flex items-center gap-3 text-[var(--muted)] py-3 border-b border-white/5" data-testid={`problem-item-${i}`}>
                    <X size={14} className="text-red-400/80 shrink-0" /> {p}
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
          <div>
            <p className="eyebrow mb-5">Mit Salgin Solutions</p>
            <ul className="space-y-3">
              {SOLUTIONS.map((p, i) => (
                <Reveal key={p} delay={0.3 + i * 0.06} y={12}>
                  <li className="flex items-center gap-3 text-[var(--text)] py-3 border-b border-[var(--line)]" data-testid={`solution-item-${i}`}>
                    <Check size={14} className="text-[var(--gold)] shrink-0" /> {p}
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="lg:col-span-5 lg:pt-20">
        <motion.div
          initial={{ clipPath: "inset(12% 12% 12% 12%)", opacity: 0 }}
          whileInView={{ clipPath: "inset(0% 0% 0% 0%)", opacity: 1 }}
          viewport={{ once: true, margin: "-15% 0px" }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
          className="frame frame-corner aspect-[3/4] border border-[var(--line)] relative"
          data-testid="problem-image"
        >
          <img src="/images/dress-studio.jpg" alt="KI-generierte Fashion-Inszenierung" className="w-full h-full object-cover" />
          <div className="veil" />
          <div className="absolute bottom-6 left-6">
            <p className="eyebrow !text-[0.6rem]">Vom Herstellerbild zur Inszenierung</p>
            <p className="font-display text-2xl text-[var(--text)] mt-1">Der erste Eindruck zählt.</p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
